module.exports = __webpack_public_path__ + "LIFT_logo-70ea7d6eff365de5df2a13d0ab00dcc4.svg";